enum ActiveCallActions {
  SET_STATE,
  SET_LOADING,
}

export { ActiveCallActions };
